import { Box, Divider, LinearProgress } from '@mui/material';
import { FC } from 'react';
import { Nullable } from 'common-types';
import {
  filterNoneOnlyFilters,
  FilterType,
  FilterTypeToFilter,
} from '../../../common/filters-utils/filters-utils';
import FilterBox from '../../../elements/FilterBox/FilterBox';
import FiltersFormContainer from '../../../elements/FiltersForm/FiltersForm';
import {
  handleChangeFilterSlider,
  handleSearchFilterType,
  onChangeFilter,
} from '../../actions/applications-filters-actions';
import config from '../../config/applications-config.json';
import { FilterApplicationsType } from '../../applications-types';
import OxSlider from '../../../elements/OxSlider/OxSlider';
import { appsFilters } from '../../utils/application-utils';
import FilterSearch from '../../../elements/FilterFormItem/FilterSearch';
import { AsyncLoadingState, LoadingStatus } from 'async-utils';

const ApplicationsSideBar: FC<
  React.PropsWithChildren<ApplicationsSideBarProps>
> = ({
  appsFiltersType,
  filterList,
  sliderBuisnessPriority,
  maxBuisnessPriority,
  setSliderBuisnessPriority,
  totalApplications,
  children,
  disabled,
  searchValues,
  appsFiltersTypeSearch,
  loadingFilters,
}) => {
  return (
    <Box
      ml={2}
      pb={2}
      width={config.sidebar.expandedSize}
      display='flex'
      flexDirection='column'
      gap={1.2}>
      {children}
      {loadingFilters.status === LoadingStatus.Pending ? (
        <LinearProgress sx={{ maxHeight: '1px' }} />
      ) : (
        <Divider sx={{ visibility: 'hidden' }} />
      )}
      {appsFiltersType && appsFiltersTypeSearch && (
        <>
          {appsFilters.map(
            filter =>
              filterNoneOnlyFilters(
                appsFiltersType[filter.type],
                totalApplications,
              ) &&
              appsFiltersType[filter.type]?.length > 0 && (
                <FilterBox
                  key={filter.header}
                  header={filter.header}
                  filtersNumber={filterList[filter.type]?.length}>
                  {filter.searchType && (
                    <FilterSearch
                      searchValue={searchValues[filter.type]}
                      onSearch={handleSearchFilterType}
                      filterType={filter.searchType}
                    />
                  )}
                  <FiltersFormContainer
                    filterByList={appsFiltersTypeSearch[filter.type]}
                    filterTypeToFilterBy={filter.type}
                    onChangeFilter={onChangeFilter}
                    filterList={filterList}
                    itemHeight={config.filters.itemHeight}
                    maxHeight={config.filters.maxHeight}
                    disabled={disabled}
                  />
                </FilterBox>
              ),
          )}
          {appsFiltersType && appsFiltersTypeSearch && (
            <FilterBox
              header={FilterType.appBusinessPriority}
              filtersNumber={filterList[FilterTypeToFilter.BusinessPriority]}>
              <Box px={4} py={2}>
                <OxSlider
                  disabled={disabled}
                  sliderValue={sliderBuisnessPriority}
                  setSliderValue={setSliderBuisnessPriority}
                  value={[config.filters.minScore, maxBuisnessPriority]}
                  minDistance={5}
                  valueLabelDisplay='auto'
                  ticks={config.filters.sliderTicks}
                  filterName={FilterTypeToFilter.BusinessPriority}
                  maxVal={maxBuisnessPriority}
                  handleChangeFilterSlider={handleChangeFilterSlider}
                />
              </Box>
            </FilterBox>
          )}
        </>
      )}
    </Box>
  );
};

export interface ApplicationsSideBarProps {
  disabled?: boolean;
  filterList: {};
  appsFiltersType: Nullable<FilterApplicationsType>;
  sliderBuisnessPriority: number[];
  maxBuisnessPriority: number;
  setSliderBuisnessPriority: (range: number[]) => void;
  totalApplications: number;
  searchValues: {};
  appsFiltersTypeSearch: Nullable<FilterApplicationsType>;
  loadingFilters: AsyncLoadingState;
}

export default ApplicationsSideBar;
